import { LastMessageText } from '@halo/ui-chat-react';
import type { Msg } from '@halo/chat-sdk-react';
import { Box } from '@chakra-ui/react';
import { Emoji } from '@/components/Emoji';
import { MsgForwardIcon } from '../../msg-parts';
import { MsgLuckyBoxPreviewContent } from './msg-lucky-box-preview-content';

export interface MsgLuckyBoxPreviewProps {
  message: Msg;
}

export const MsgLuckyBoxPreview = memo(function MsgLuckyBoxPreview({
  message,
}: MsgLuckyBoxPreviewProps) {
  return (
    <LastMessageText>
      <Emoji.MessagePrefix reactions={message.emoji_reaction} />
      <MsgForwardIcon message={message} />
      <Box flex="1" minW="0" truncate>
        <MsgLuckyBoxPreviewContent />
      </Box>
    </LastMessageText>
  );
});
